module.exports = __webpack_public_path__ + "e8fc3485755b50eef073ab99ae325f48.png";